import React, { Component } from "react";
import { Switch, Route, withRouter, NavLink } from "react-router-dom";
import { I18n } from "react-i18next";
import "../utils/i18n";
import "./SearchUnified.css";
import SearchForm from "./SearchForm";
import LoadingSpinner from "../utils/LoadingSpinner";
import OrgelsucheResult from "./OrgelsucheResult";
import OrgelbauerResult from "./OrgelbauerResult";
import KarteResult from "./KarteResult";
import Menu from "../app-header/Menu";
import ErrorMessage from "../utils/ErrorMessage";
import api from "../api/api";
import Rx from "rxjs";

const initialState = {
  searchTerm: "",
  loadingOrgel: false,
  loadingOrgelbauer: false,
  resultOrgel: undefined,
  resultOrgelbauer: undefined
};

class SearchUnified extends Component {
  constructor(props) {
    super(props);
    this.state = initialState;

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }
  componentWillReceiveProps(newProps) {
    if (!this.state.searchTerm) {
      return;
    }
    if (this.state.loadingOrgel || this.state.loadingOrgelbauer) {
      this.search(newProps.location.pathname);
    }
  }
  componentDidMount() {
    const persistedSearchUnifiedState = sessionStorage.getItem(
      "searchUnifiedState"
    );
    if (persistedSearchUnifiedState) {
      this.setState(JSON.parse(persistedSearchUnifiedState), () => {
        // search if data not loaded
        if (!this.state.searchTerm) {
          return;
        }
        if (this.state.loadingOrgel || this.state.loadingOrgelbauer) {
          this.search(this.props.location.pathname);
        }
      });
    }
  }
  componentWillUnmount() {
    if (this.search$ !== undefined) {
      this.search$ = this.search$.unsubscribe();
    }
  }
  search(pathname) {
    this.setState({ loadingOrgel: true, loadingOrgelbauer: true });

    let search;
    if (pathname.includes("orgelsuche") || pathname.includes("karte")) {
      search = api
        .searchOrgel(this.state.searchTerm)
        .catch(err => this.setState({ error: err }))
        .concatMap(result => {
          this.setState({
            loadingOrgel: false,
            resultOrgel: result,
            error: undefined
          });
          return api.searchOrgelbauer(this.state.searchTerm);
        })
        .concatMap(result => {
          this.setState({
            loadingOrgelbauer: false,
            resultOrgelbauer: result
          });
          return Rx.Observable.empty;
        });
    } else if (pathname.includes("orgelbauer")) {
      search = api
        .searchOrgelbauer(this.state.searchTerm)
        .catch(err => this.setState({ error: err }))
        .concatMap(result => {
          this.setState({
            loadingOrgelbauer: false,
            resultOrgelbauer: result,
            error: undefined
          });
          return api.searchOrgel(this.state.searchTerm);
        })
        .concatMap(result => {
          this.setState({
            loadingOrgel: false,
            resultOrgel: result
          });
          return Rx.Observable.empty;
        });
    }

    this.search$ = search.subscribe(() =>
      sessionStorage.setItem("searchUnifiedState", JSON.stringify(this.state))
    );
  }

  handleChange(event) {
    this.setState({ searchTerm: event.target.value });
  }
  handleSubmit(event) {
    event.preventDefault();
    this.search(this.props.location.pathname);
  }

  render() {
    return (
      <I18n>
        {(t, { i18n }) => (
          <div>
            <Menu />
            <SearchForm
              searchTerm={this.state.searchTerm}
              handleSubmit={this.handleSubmit}
              handleChange={this.handleChange}
            />
            <div className="row search-tabnav">
              <div className="offset3 span8">
                <ul className="tabnav">
                  <li>
                    <NavLink
                      to="/search-unified/orgelsuche"
                      activeClassName="active"
                    >
                      <i className="icon ion-search" />{" "}
                      {t("navigation.Orgelsuche")}
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="/search-unified/orgelbauer"
                      activeClassName="active"
                    >
                      <i className="icon ion-person" />{" "}
                      {t("navigation.Orgelbauersuche")}
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="/search-unified/karte"
                      activeClassName="active"
                    >
                      <i className="icon ion-map" />{" "}
                      {t("navigation.Kartensuche")}
                    </NavLink>
                  </li>
                </ul>
              </div>
            </div>
            <div className="row search-tabnav-border" />
            {this.state.error !== undefined && (
              <div className="row">
                <div className="offset3 span6 error-container">
                  <ErrorMessage error={this.state.error} />
                </div>
              </div>
            )}
            <div>
              <Switch>
                <Route path="/search-unified/orgelsuche">
                  <LoadingSpinner loading={this.state.loadingOrgel}>
                    <OrgelsucheResult
                      result={this.state.resultOrgel}
                      searchTerm={this.state.searchTerm}
                    />
                  </LoadingSpinner>
                </Route>
                <Route path="/search-unified/orgelbauer">
                  <LoadingSpinner loading={this.state.loadingOrgelbauer}>
                    <OrgelbauerResult
                      result={this.state.resultOrgelbauer}
                      searchTerm={this.state.searchTerm}
                    />
                  </LoadingSpinner>
                </Route>
                <Route path="/search-unified/karte">
                  <LoadingSpinner loading={this.state.loadingOrgelbauer}>
                    <KarteResult
                      result={this.state.resultOrgel}
                      searchTerm={this.state.searchTerm}
                    />
                  </LoadingSpinner>
                </Route>
              </Switch>
            </div>
          </div>
        )}
      </I18n>
    );
  }
}

export default withRouter(SearchUnified);



// WEBPACK FOOTER //
// ./src/search-unified/SearchUnified.js